"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enhancedTraits = void 0;
const enhancedTraits = () => {
    let user;
    const enrichTraits = (ctx) => {
        const traits = user.traits();
        if (traits && Object.keys(traits).length === 0)
            return ctx;
        const { email, first_name, last_name } = traits || {};
        ctx.updateEvent("context.traits", {
            email,
            first_name,
            last_name,
        });
        // Add here for now but probably should be a different plugin
        ctx.updateEvent("properties.segment_message_id", ctx.event.messageId);
        return ctx;
    };
    return {
        name: "Enhanced Traits",
        type: "enrichment",
        version: "0.1.0",
        load: (_ctx, ajs) => __awaiter(void 0, void 0, void 0, function* () {
            user = ajs.user();
        }),
        isLoaded: () => user !== undefined,
        page: enrichTraits,
        track: enrichTraits,
    };
};
exports.enhancedTraits = enhancedTraits;
